export const checkEnvironment = () => {
	const instance = import.meta.env.VITE_SUPABASE_URL;
	if (instance?.includes('ghhmc')) return 'prod';
	if (instance?.includes('eqkst')) return 'staging';
	if (instance?.includes('esrmx')) return 'georges';
	if (instance?.includes('http://')) return 'local';
	return undefined;
};
